/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Realitni_TrzniceInputs */

const cs_enum_realitni_trznice = /** @type {(inputs: Enum_Realitni_TrzniceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realitní tržnice`)
};

const en_enum_realitni_trznice = /** @type {(inputs: Enum_Realitni_TrzniceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realitní tržnice`)
};

/**
* | output |
* | --- |
* | "Realitní tržnice" |
*
* @param {Enum_Realitni_TrzniceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_realitni_trznice = /** @type {((inputs?: Enum_Realitni_TrzniceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Realitni_TrzniceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_realitni_trznice(inputs)
	return cs_enum_realitni_trznice(inputs)
});